import React, { useState, useEffect, useRef } from 'react';

import fiboHi from '../../assets/fibo-hi.png';

//import { Typography, Button } from 'fibe-ui';
import Typography from '../Typography/Typography.jsx';
import { LottieWrapper } from '../../fibe-ui/index';

function ConvUICard({
  typeOfCard = 'QUESTION',
  prevQuestionRemark,
  mainQuestion,
  welcomeSubtitle,
  questionsSubDetails,
  buttonText,
  inputType,
  welcomeImagePresent,
  welcomeImageLottieData,
  lottieWidth,
  lottieHeight,
  subLinkText,
  multipleChoiceOptions,
  singleChoiceOptions,
  CTAClickFn,
  CTABtnAlignments,
  scrollOneBlockUp = () => {},
  blockId = 0,
  activeBlock = 0,
  childComponent,
  loadingComp,
  footerNotes,
  drawerSidebarLinkText,
  drawerSidebarLinkAction,
  CTADisabled = false,
  subLinkTextClickFn = () => {},
  subChildComponent = <></>,
  ...rest
}) {
  const [isShowBlock, setisShowBlock] = useState(1);
  const [showCTABtns, setShowCTABtns] = useState(true);
  const [convBoxPadding, setConvBoxPadding] = useState('p-6');
  const refConvUiCard = useRef(null);

  useEffect(() => {
    const topPosition = refConvUiCard.current.getBoundingClientRect().top;
    // console.log({ topPosition });
    if (topPosition < 0) {
      setShowCTABtns(false);
      setConvBoxPadding('px-6 pt-6');
    }
  }, [refConvUiCard]);

  const localCTAClickFn = () => {
    if (CTAClickFn) CTAClickFn();
  };

  const getInputComponent = (type) => {
    if (!type) return '';

    const typeLower = type.toLowerCase();
    switch (typeLower) {
      case 'text':
        return (
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none mb-3 focus:shadow-outline"
            id="username"
            type="text"
            placeholder="Enter your good name😁"
          />
        );
      case 'component':
        return '';
      case 'no-card':
        return '';

      case 'loader':
        return (
          <>
            {loadingComp ? (
              loadingComp
            ) : (
              <div className="flex justify-center items-center">
                <div
                  className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </>
        );
      default:
        return 'default';
    }
  };

  return (
    <div
      ref={refConvUiCard}
      className={`flex flex-col justify-center mr-4  items-center md:items-end md:items-start md:justify-end w-full ${
        !isShowBlock ? ' hidden ' : ''
      }`}
      // style={{ height: '65vh' }}
      onClick={() => scrollOneBlockUp(blockId)}
      {...rest}
    >
      <p className="text-gray-400 font-normal italic mb-0 mr-auto pl-6">
        {prevQuestionRemark}
      </p>
      <div
        className={`block ${convBoxPadding} pt-2 pb-24 mobile:mt-8 lg:pb-2 rounded-lg max-w-sm`}
        style={{
          ...(activeBlock !== blockId
            ? {
                pointerEvents: 'none',
              }
            : {}),
          minWidth: '100%',
        }}
      >
        {welcomeImagePresent ? (
          welcomeImageLottieData ? (
            <div className="lottie-holder-div flex justify-start items-start my-2">
              <LottieWrapper
                animationData={welcomeImageLottieData}
                height={`${lottieHeight}px` || '300px'}
                width={`${lottieWidth}px` || '300px'}
              />
            </div>
          ) : (
            <img className="w-24" src={fiboHi} />
          )
        ) : (
          ''
        )}
        <Typography variant="h2" text={mainQuestion} />
        {welcomeSubtitle && (
          <div className="py-2">
            <Typography variant="h2" text={welcomeSubtitle} />
          </div>
        )}
        {questionsSubDetails && (
          <div className="pt-2 short1:pt-4">
            <Typography variant="sub-title" text={questionsSubDetails} />
          </div>
        )}
        {drawerSidebarLinkText ? (
          <div
            className="pt-2 text-black-600 underline cursor-pointer hover:text-black-8"
            onClick={
              drawerSidebarLinkAction ? drawerSidebarLinkAction() : () => {}
            }
          >
            {drawerSidebarLinkText}
          </div>
        ) : (
          ''
        )}
        <div className="flex flex-col items-end">
          {subChildComponent}
          {childComponent ? childComponent : ''}
          {getInputComponent(inputType)}
          {showCTABtns ? (
            <div
              className={`flex flex-col w-full my-1 ${
                typeOfCard !== 'QUESTION'
                  ? 'items-start justify-start'
                  : 'items-end justify-end'
              }`}
            >
              {buttonText ? (
                <div className={`pt-2 ack-screen-cta`}>
                  <button
                    disabled={CTADisabled}
                    className="bg-[#079F9F] ack-screen-cta text-white inline-block md:w-72 px-1 py-4  rounded-lg text-sm font-semibold focus:outline-none tracking-wider bg-accent text-text-light hover:bg-btn-active disabled:bg-[#045656] active:bg-btn-active transition duration-200 ease-in-out "
                    onClick={localCTAClickFn}
                  >
                    {buttonText}
                  </button>
                </div>
              ) : (
                ''
              )}
              {subLinkText ? (
                <button
                  className={`mobile:m-auto ack-screen-cta  mobile:my-1  mt-1 text-cyan-500 background-transparent font-bold mobile:px-0 px-6 py-2 text-sm outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150`}
                  type="button"
                  style={{ color: '#079F9F' }}
                  onClick={subLinkTextClickFn}
                >
                  {subLinkText}
                </button>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </div>
        {footerNotes ? (
          <div className="flex flex-row justify-end items-end py-2">
            <p className="w-full text-xs font-normal">{footerNotes}</p>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default ConvUICard;
